import { Loader2 } from 'lucide-react';
import { FornitaliaLogo } from './FornitaliaLogo';
import { SplashBackdrop } from './SplashBackdrop';

/**
 * Full-page splash used during session bootstrap / initial auth check.
 * Mirrors the PowerApps loading screen: centered wordmark + soft spinner +
 * decorative red curve at the bottom.
 */
export function SplashScreen({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="relative flex h-dvh w-full flex-col items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-8 pb-32">
        <FornitaliaLogo variant="horizontal" size="lg" />
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
        <span className="sr-only">{label}</span>
      </div>
      <SplashBackdrop />
    </div>
  );
}
